
export const trVisaOptions = [
  { value: 'var', label: 'Var' },
  { value: 'yok', label: 'Yok' },
  { value: 'vize_gerekmiyor', label: 'Vize Gerekmiyor' },
];

export const enVisaOptions = [
  { value: 'var', label: 'Yes, I have a valid visa' },
  { value: 'yok', label: 'No, I don’t have a valid visa' },
  { value: 'vize_gerekmiyor', label: 'No Visa Required (NVR)' },
];



// WEBPACK FOOTER //
// ./src/constants/visa-options.js